import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';

import { renderInput } from 'src/components/misc/redux-form-helpers';
import { isInteger } from 'src/common/index';
import MultiLanguageInput, { languages } from 'src/components/misc/multi-language-input';
import { isBlank } from 'src/components/misc/validations';

class ReviewCategoryEditForm extends Component {
    render() {
        const { handleSubmit, t } = this.props;

        return (
            <form className="form-horizontal" onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-md-12">
                        <Field
                            name="name"
                            placeholder={t('common_phrases.name')}
                            label={`${t('common_phrases.name')} *`}
                            t={t}
                            component={MultiLanguageInput}
                            componentType="renderInput"
                        />
                    </div>
                    <div className="col-md-6">
                        <Field
                            name="factor"
                            label={t('review_categories.factor')}
                            component={renderInput}
                            type="number"
                            step={0.1}
                        />
                    </div>
                    <div className="col-md-6">
                        <Field
                            name="position"
                            label={t('review_categories.position')}
                            hintText={t('review_categories.position_hint')}
                            component={renderInput}
                            type="number"
                        />
                    </div>
                </div>
            </form>
        );
    }
}

const validate = (values, props) => {
    const { t } = props;
    const errors = {};

    errors.name = {};
    if (isBlank(values.name) || Object.values(values.name).every(value => isBlank(value))) {
        languages.forEach(language => {
            errors.name[language.code] = t('error_missing.fill_in');
        });
    } else errors.name = null;

    if (!isInteger(values.position)) errors.position = t('error_hint.error_integer');
    if (values.position < -100 || values.position > 100) errors.position = t('bus.error_order');

    if (values.factor < 0 || values.factor > 1) errors.factor = t('review_categories.fill_in_factor');

    return errors;
};

export default reduxForm({
    form: 'reviewCategoryEditForm',
    validate,
    asyncBlurFields: ['category'],
})(ReviewCategoryEditForm);
